/**
 * Скроллбар виден, только пока листают, — как на macOS.
 *
 * Один слушатель прокрутки на весь документ (в фазе перехвата: scroll не всплывает)
 * ставит прокручиваемому блоку `data-scrolling` и снимает его через мгновение после
 * остановки. Как выглядит бегунок, решает CSS (`styles/index.css`) по этому атрибуту —
 * компонентов и правок в местах прокрутки не нужно. Атрибут, а не класс: React
 * перезаписывает className при перерисовке и стёр бы отметку посреди прокрутки.
 */

/** Сколько бегунок ещё виден после остановки прокрутки, мс */
const HIDE_DELAY = 900;

const timers = new WeakMap<Element, number>();

export const showScrollbarsWhileScrolling = () => {
	document.addEventListener(
		"scroll",
		(event) => {
			// Прокрутка страницы приходит от document — её скроллбар у <html>
			const target = event.target === document ? document.documentElement : event.target;
			if (!(target instanceof Element)) return;
			if (!target.hasAttribute("data-scrolling")) target.setAttribute("data-scrolling", "");
			window.clearTimeout(timers.get(target));
			timers.set(
				target,
				window.setTimeout(() => {
					target.removeAttribute("data-scrolling");
					timers.delete(target);
				}, HIDE_DELAY),
			);
		},
		{ capture: true, passive: true },
	);
};
